<template>
    <div class="white-wrapper">
        <main class="about">
            <div class="about__wrapper">
                <div class="about__big-title">
                    <span>Yarının Suyu - Künye</span>
                </div>

                <div class="about__description-container">
                    <div class="about__logo-wrapper">
                        <div class="about__logo">
                            <img src="../assets/sub_page_images/finish@2x.png">
                        </div>
                    </div>
                    <div class="about__description">
                        <span class="about__description-title">Konu bulaşıklar olunca çözüm Finish!</span>
                        <p class="about__description-text">
                            1987 yılından beri bulaşık makinesinde bulaşık yıkamaya dair aklınıza gelen bütün konularda çözüm sağlamak için çalışıyoruz.
                            Calgonit Bulaşık Deterjanı, Calgonit Parlatıcı ve Calgonit Tuz ile Türkiye pazarına giren markamız, 2010 yılından itibaren Finish adı altında bulaşık makinesi tabletleri, jeli, ve özel tuzu ile bulaşık yıkamayı kolaylaştırmakta; bunun yanında parlatıcı, makine temizleyici ve makine kokusu gibi katkı maddeleriyle de makinenizden %100 performans alabilmeniz için akıllı çözümler sunmaktadır.
                        </p>
                        <a href="#" class="about__description-url">finish.com.tr</a>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "AboutUs",
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
        }
    }
</script>

<style lang="scss">


    $base-width: 1140px;
    $icon-font: "Font Awesome 5 Free";


.white-wrapper {

    background-color: white;
    width: 100%;
}


    .about{
        min-height: calc(100vh - 121px);
        color: black;

    &__wrapper{
        width: $base-width;
        margin: 50px auto;
    }

    &__big-title{
        font-size: 25px;
        font-weight: bold;
        color: black;
        text-align: center;
        margin-bottom: 100px;
    }

    &__description-container{
        display: flex;
        justify-content: center;
        position: relative;
    }

    &__logo-wrapper{
        width: 178px;
        height: 178px;
        background-image: linear-gradient(to top, #e2e2e2, #ececec -100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 250px;
        top: -20px;
    }
    &__logo{
        width: 130px;
        margin-top: -20px;
        >img{
            width: 100%;
        }
    }
    &__description{
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 15px;
        border-radius: 50%;
        border: solid 1px #dadada;
        width: 470px;
        height: 470px;
        justify-content: center;
        margin-top: 25px;
    }
    &__description-title{
        font-weight: bold;
    }
    &__description-text{
        padding: 0 50px;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 30px;
    }
    &__description-url{
        font-size: 15px;
        font-weight: bold;
        color: black;
        text-decoration: underline;
    }
}


@media screen and (max-width: 600px) {
    .about{

        &__wrapper{
            width: 100%;
        }
        &__logo-wrapper{
            left: auto;
            top: -85px;
        }
        &__big-title{
            margin-bottom: 130px;
        }
    }   
}

</style>